<template><recursos-pagina v-if="fechamento" :municipio-id="$route.params.municipioId" /><legacy-list v-else /></template>
<script>
import RecursosPagina from '@/modules/selo-fechamento/components/RecursosPagina.vue';
import LegacyList from './List.vue';
export default { name: 'ResourceClosingEntry', components: { RecursosPagina, LegacyList }, computed: { fechamento() { const config=JSON.parse(localStorage.getItem('config') || '{}'); return config.fechamentoSelo === true; } } };
</script>
